import { useTranslation } from 'react-i18next';
import BalanceSheetTable from './BalanceSheetTable';
import './BottomPanel.css';

interface BottomPanelProps {
  institutionId: string;
  reportPeriod: string;
  isExpanded: boolean;
  onToggleExpand: () => void;
}

export default function BottomPanel({
  institutionId,
  reportPeriod,
  isExpanded,
  onToggleExpand,
}: BottomPanelProps) {
  const { t } = useTranslation();

  return (
    <div className={`bottom-panel ${isExpanded ? 'expanded' : ''}`}>
      {/* Panel Header */}
      <div className="bottom-panel-header">
        <h3 className="panel-title">{t('editorBottom.title')}</h3>
        <div className="panel-actions">
          <span className="period-label">{reportPeriod}</span>
          <button
            className="expand-btn"
            onClick={onToggleExpand}
            title={isExpanded ? t('editorBottom.collapsePanel') : t('editorBottom.expandPanel')}
          >
            {isExpanded ? `▼ ${t('editorBottom.collapse')}` : `▲ ${t('editorBottom.expand')}`}
          </button>
        </div>
      </div>

      {/* Data Table */}
      <div className="panel-content">
        <BalanceSheetTable
          institutionId={institutionId}
          reportPeriod={reportPeriod}
        />
      </div>
    </div>
  );
}
